/*eslint-disable*/
import { Flex, Link, List, ListItem, Text } from "@chakra-ui/react";
import React from "react";

export default function Footer(props) {
  return (
    <Flex
      flexDirection='column'
      alignItems='center'
      justifyContent='center'
      px='30px'
      pb='20px'
      direction="rtl">
      <Text
        color='gray.400'
        textAlign='center'
        mb={{ base: "20px", xl: "0px" }}>
        &copy; {1900 + new Date().getYear()}, {" "}
        <Text as='span'>
        {"Made with ❤️ by "}
        </Text>
        <Link
          color='blue.400'
          href='https://codewell.taskati.net/'
          target='_blank'>
          CodeWell
        </Link>
        
     
      </Text>
      <List display='flex'>
        <ListItem
          ms={{
            base: "20px",
            md: "44px",
          }}>
          
        </ListItem>
        
      </List>
    </Flex>
  );
}
